export const GET_FIELDS_ORDER = 'GET_FIELDS_ORDER';
export const GET_FIELDS_ORDER_SUCCESS = 'GET_FIELDS_ORDER_SUCCESS';
export const GET_FIELDS_ORDER_FAIL = 'GET_FIELDS_ORDER_FAIL';

export const SAVE_FIELDS_ORDER = 'SAVE_FIELDS_ORDER';
export const SAVE_FIELDS_ORDER_SUCCESS = 'SAVE_FIELDS_ORDER_SUCCESS';
export const SAVE_FIELDS_ORDER_FAIL = 'SAVE_FIELDS_ORDER_FAIL';

export const FIELDS_ORDER_INITIAL_STATE = 'FIELDS_ORDER_INITIAL_STATE';
